import './sky-comparison.scss';

(function () {
    'use strict';

    // Initialize comparison functionality
    function initComparisonBlock() {
        const comparisonBlocks = document.querySelectorAll('.sky-comparison-block');

        comparisonBlocks.forEach(block => {
            const grid = block.querySelector('.comparison-grid');
            const panel = block.querySelector('.comparison-panel');
            const table = block.querySelector('#comparisonTable');

            if (!grid || !panel || !table) return;

            let selected = [];

            // Handle element selection
            function handleElementSelection(card) {
                const id = card.dataset.id;
                let elementData = {};

                // Safely parse element data
                try {
                    elementData = JSON.parse(card.dataset.element || '{}');
                } catch (error) {
                    const errorMsg = window.comparisonBlockStrings?.errorParsing || 'Error parsing element data:';
                    console.warn(errorMsg, error);
                    elementData = { name: '', specs: [] };
                }

                // Get the visual position of the card (for left-to-right ordering)
                const allCards = Array.from(grid.querySelectorAll('.element-card'));
                const position = allCards.indexOf(card);

                if (card.classList.contains('selected')) {
                    // Deselect if already selected
                    card.classList.remove('selected');
                    card.setAttribute('aria-pressed', 'false');
                    selected = selected.filter(item => item.id !== id);
                } else {
                    if (selected.length === 2) {
                        // Third click clears previous choices
                        block.querySelectorAll('.element-card.selected').forEach(c => {
                            c.classList.remove('selected');
                            c.setAttribute('aria-pressed', 'false');
                        });
                        selected = [];
                    }
                    card.classList.add('selected');
                    card.setAttribute('aria-pressed', 'true');
                    selected.push({ id, data: elementData, position });
                }

                updateComparison();
            }

            // Handle clicks on element cards
            grid.addEventListener('click', (e) => {
                const card = e.target.closest('.element-card');
                if (!card) return;
                handleElementSelection(card);
            });

            // Handle keyboard interaction (Enter/Space)
            grid.addEventListener('keydown', (e) => {
                const card = e.target.closest('.element-card');
                if (!card) return;

                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleElementSelection(card);
                }
            });

            // Update comparison table
            function updateComparison() {
                if (selected.length === 2) {
                    // Sort by position to ensure left-to-right order
                    const sortedItems = [...selected].sort((a, b) => a.position - b.position);
                    const [itemA, itemB] = sortedItems;

                    // Update column headers with element names
                    const colA = table.querySelector('#colA');
                    const colB = table.querySelector('#colB');
                    const itemAText = window.comparisonBlockStrings?.itemA || 'Item A';
                    const itemBText = window.comparisonBlockStrings?.itemB || 'Item B';

                    if (colA) colA.textContent = itemA.data.name || itemAText;
                    if (colB) colB.textContent = itemB.data.name || itemBText;

                    // Update specification values
                    const specRows = table.querySelectorAll('tbody tr[data-spec-slug]');
                    if (specRows.length === 0) {
                        // No specification rows (might have a "no specifications" message row)
                        panel.classList.add('open');
                        return;
                    }

                    // Two-pass approach to prevent duplicate values:
                    // 1. First pass: Match by slug (highest priority)
                    // 2. Second pass: Match by index (only for remaining empty cells)
                    // This ensures each specification value appears only once

                    // Track which spec values have been used to avoid duplicates
                    const usedSpecsA = new Set();
                    const usedSpecsB = new Set();

                    // First pass: match by slug
                    specRows.forEach((row) => {
                        const specSlug = row.dataset.specSlug;
                        const cellA = row.querySelector('[data-spec="specA"]');
                        const cellB = row.querySelector('[data-spec="specB"]');

                        if (cellA && cellB) {
                            // Safely get specs with null checks
                            const specsA = itemA.data.specs || [];
                            const specsB = itemB.data.specs || [];

                            // Try to find values by slug
                            let valueA = '';
                            let valueB = '';

                            // Find spec A by slug
                            const specAIndex = specsA.findIndex(s => s && s.slug === specSlug);
                            if (specAIndex !== -1 && specsA[specAIndex]) {
                                valueA = specsA[specAIndex].value || '';
                                usedSpecsA.add(specAIndex);
                            }

                            // Find spec B by slug
                            const specBIndex = specsB.findIndex(s => s && s.slug === specSlug);
                            if (specBIndex !== -1 && specsB[specBIndex]) {
                                valueB = specsB[specBIndex].value || '';
                                usedSpecsB.add(specBIndex);
                            }

                            cellA.textContent = valueA || '';
                            cellB.textContent = valueB || '';
                            cellA.dataset.filled = valueA ? 'true' : 'false';
                            cellB.dataset.filled = valueB ? 'true' : 'false';
                        }
                    });

                    // Second pass: fill remaining empty cells by index
                    specRows.forEach((row, rowIndex) => {
                        const cellA = row.querySelector('[data-spec="specA"]');
                        const cellB = row.querySelector('[data-spec="specB"]');

                        if (cellA && cellB) {
                            const specsA = itemA.data.specs || [];
                            const specsB = itemB.data.specs || [];

                            // Fill A if still empty
                            if (cellA.dataset.filled === 'false') {
                                // Look for an unused spec value at this row index
                                if (!usedSpecsA.has(rowIndex) && specsA[rowIndex] && specsA[rowIndex].value) {
                                    cellA.textContent = specsA[rowIndex].value;
                                    usedSpecsA.add(rowIndex);
                                } else {
                                    cellA.textContent = '—';
                                }
                            }

                            // Fill B if still empty
                            if (cellB.dataset.filled === 'false') {
                                // Look for an unused spec value at this row index
                                if (!usedSpecsB.has(rowIndex) && specsB[rowIndex] && specsB[rowIndex].value) {
                                    cellB.textContent = specsB[rowIndex].value;
                                    usedSpecsB.add(rowIndex);
                                } else {
                                    cellB.textContent = '—';
                                }
                            }

                            // Clean up data attributes
                            delete cellA.dataset.filled;
                            delete cellB.dataset.filled;
                        }
                    });

                    // Open the panel
                    panel.classList.add('open');
                } else {
                    // Close the panel
                    panel.classList.remove('open');
                }
            }

        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initComparisonBlock);
    } else {
        initComparisonBlock();
    }

    // Re-initialize on Gutenberg block updates (for editor)
    if (window.acf) {
        window.acf.addAction('render_block_preview', function () {
            setTimeout(initComparisonBlock, 100);
        });
    }
})();